import { SHOP_SOURCES } from "./constants/shopSources";
import { decodeHtml } from "./richText";

// Pickers (product, category, decorations, marketing, ...) store the picked item as a JSON ref
// like { source, productId } in a string property. Shared parser for that ref shape: returns the
// parsed object, or null when the value is not a JSON object. The delivery API HTML-escapes
// string properties, so the JSON arrives escaped and is decoded before parsing.
export const parseRef = (raw) => {
    if (!raw || typeof raw !== "string") return null;
    try {
        const parsed = JSON.parse(decodeHtml(raw));
        return parsed && typeof parsed === "object" ? parsed : null;
    } catch (e) {
        return null;
    }
};

// The identifier to look a referenced node up by, from a picker ref or a resolved delivery node.
// JCR: @path first (unique across the tree), then @id (a uuid — the services resolve either).
// Other sources: @id first. A bare @name only when `allowName` is set, as a last resort for JCR
// and second for external sources: it is only unique among siblings and cannot be resolved to
// a node, but is fine for building a link.
export const getRefIdentifier = (ref, { allowName = false } = {}) => {
    const name = allowName ? ref["@name"] : undefined;

    return (ref.source || SHOP_SOURCES.JCR) === SHOP_SOURCES.JCR
        ? ref["@path"] || ref["@id"] || ref.categoryId || ref.productId || ref.id || name
        : ref["@id"] || name || ref.categoryId || ref.productId || ref.id;
};
